import React from "react";
import LoginForm from "./components/loginForm";
import "./styles/loginForm.css";

function App() {
  return (
    <div className="App">
      <LoginForm />
    </div>
  );
}

export default App;
